import { enableProdMode, importProvidersFrom, inject, isDevMode, provideAppInitializer } from '@angular/core';

import { environment } from '@adm-web-env/environment';

import { BASE_PATH, ComponentType, HX_APP_VERSION, HX_COMPONENT_NAME, HX_ENV_MODE, initKeycloak, provideKeycloakFn, provideTranslocoFn } from 'hx-services';
import { APP_VERSION } from '@adm-web-env/version';
import { provideHttpClient, withInterceptors, withJsonpSupport } from '@angular/common/http';
import { bootstrapApplication } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';
import { createInterceptorCondition, INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG, IncludeBearerTokenCondition, includeBearerTokenInterceptor } from 'keycloak-angular';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { appRoutes } from '@adm-web-app/app.routing';
import { TranslocoService } from '@jsverse/transloco';
import { provideServiceWorker } from '@angular/service-worker';
import { NzModalService } from 'ng-zorro-antd/modal';
import { provideNzI18n, ru_RU } from 'ng-zorro-antd/i18n';
import { addI18n } from 'hx-components';
import { customHttpInterceptorFn } from '@adm-web-app/interceptors/custom-http.interceptor';
import { provideToastr } from 'ngx-toastr';
import { provideMarkdown } from 'ngx-markdown';
import { registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru';

if (environment.production) {
  enableProdMode();
}


registerLocaleData(localeRu);

function getKeycloakUrl() {
  if (environment.production) {
    return location.origin.replace(location.origin.split('//')[1].split('.')[0], 'auth') + '/auth';
  }
  return environment.keycloakUrl;
}

const urlCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: /^\/api\/.*/,
  bearerPrefix: 'Bearer',
});

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(FormsModule, ReactiveFormsModule),
    provideRouter(appRoutes, withRouterConfig({
      // scrollPositionRestoration: 'disabled'
    })),
    NzModalService,
    provideTranslocoFn(),
    provideNzI18n(ru_RU),
    provideKeycloakFn({
      url: getKeycloakUrl(),
      realm: environment.keycloakRealm,
      clientId: environment.keycloakClientId,
    }),
    provideAppInitializer(() => {
      const tr = inject(TranslocoService);
      addI18n(tr);
      return initKeycloak();
    }),
    provideMarkdown(),
    provideHttpClient(withJsonpSupport(), withInterceptors([includeBearerTokenInterceptor, customHttpInterceptorFn])),
    provideEnvironmentNgxMask(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    {
      provide: BASE_PATH,
      useValue: ''
    },
    {
      provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: [urlCondition]
    },
    {
      provide: HX_COMPONENT_NAME,
      useValue: ComponentType.adm
    },
    {
      provide: HX_ENV_MODE,
      useValue: environment.production
    },
    {
      provide: HX_APP_VERSION,
      useValue: APP_VERSION
    },
    provideAnimations(),
    provideToastr(),
  ]
})
  .catch(err => console.error(err));
